// extracted by mini-css-extract-plugin
export default {"-large":"fonts-brand-section-module__-large--TPIGV","container":"fonts-brand-section-module__container--GOZoV","divider":"fonts-brand-section-module__divider--sXrFo"};